import React, { useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DesignationPermissionTable from "../../components/Permissions/DesignationPermissionTable";

const Permissions = () => {

  return (
    <div className="page-content">
      <Breadcrumbs title="Settings" breadcrumbItem="Permissions" />
      <DesignationPermissionTable />
    </div>
  );
};

export default Permissions;